module.exports = __webpack_public_path__ + "static/media/cloud-researcher.0d5299ec.svg";